import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const OverviewIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="OverviewIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/overview">
            <g id="Vector">
                <path d="M3 12H3.01H3Z" fill="currentColor"></path>
                <path d="M3 18H3.01H3Z" fill="currentColor"></path>
                <path d="M3 6H3.01H3Z" fill="currentColor"></path>
                <path d="M8 12H21H8Z" fill="currentColor"></path>
                <path d="M8 18H21H8Z" fill="currentColor"></path>
                <path d="M8 6H21H8Z" fill="currentColor"></path>
                <path
                    d="M3 12H3.01M3 18H3.01M3 6H3.01M8 12H21M8 18H21M8 6H21"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </g>
        </g>
    </SvgIcon>
)
